import React, { useState, useEffect } from 'react'
import Logo from '../atoms/Logo'

function Navbar() {
  const menuItems = [
    { title: 'About', link: '#aboutMe' },
    { title: 'Projects', link: '#projects' },
    { title: 'Contact', link: '#contact' },
  ]

  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  const closeMenu = () => {
    setIsMenuOpen(false)
  }

  return (
    <>
      <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
        <div className="navbar-container">
          <a href="#home" className="navbar-logo">
            <Logo />
            <span>Freddy</span>
          </a>

          <ul className="navbar-menu">
            {menuItems.map((item) => (
              <li key={item.title}>
                <a href={item.link}>{item.title}</a>
              </li>
            ))}
          </ul>

          <div className="navbar-hamburger" onClick={toggleMenu}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </nav>

      <div className={`mobile-menu ${isMenuOpen ? 'open' : ''}`}>
        {menuItems.map((item) => (
          <a key={item.title} href={item.link} onClick={closeMenu}>
            {item.title}
          </a>
        ))}
      </div>
    </>
  )
}

export default Navbar
